import react, { useState, Fragment, useEffect } from "react";
//import { usePlacesWidget } from "react-google-autocomplete";
import Searchtype from "./Searchtype";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const Landing = (porps) => {
  const webLanguage = localStorage.getItem("lang");
  const { t } = useTranslation("translation", { keyPrefix: "landing" });
  const [customval, setCustomval] = useState("");
  const [isValidLocation, setIsValidLocation] = useState(true);
  const [showGetCurrentLocation, setShowGetCurrentLocation] = useState(true);
  const [issearchtypevisible, setIssearchtypevisible] = useState(false);
  const [displaysearchresult, setDisplaysearchresult] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const isDisplayresult = useSelector((index) => index.isDisplayresult);
  const subCategoryId = useSelector((index) => index.subCategoryId);
  const categoryId = useSelector((index) => index.categoryId);
  const place = useSelector((index) => index.place);
  const keyword = useSelector((index) => index.keyword);
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  //const loadsrc = useCustomloadapi();
  useEffect(async () => {
    // console.log("first");
    let locationURL = queryParams.get("location");
    let typeURL = queryParams.get("type");
    const categoryURL = queryParams.get("category");
    const subcategoryURL = queryParams.get("subcategory");
    const keywordURL = queryParams.get("keyword");
    const resourceTypeURL = queryParams.get("resourceType");
    const languagesURL = queryParams.get("languages");
    const communitiesURL = queryParams.get("communities");
    const accessibilitiesURL = queryParams.get("accessibilities");
    const costsURL = queryParams.get("costs");
    if (locationURL === null) locationURL = "";
    if (typeURL === null) typeURL = "";
    // console.log(locationURL, typeURL, categoryURL, subcategoryURL, keywordURL, resourceTypeURL, languagesURL, communitiesURL, accessibilitiesURL, costsURL);
    if (typeURL.length > 0) {
      // setIssearchtypevisible(true);
      // console.log(locationURL);
      try {
        // console.log("HERER");
        if(locationURL.length > 0 )
        {
          dispatch(ramactions.updateSeachBy(typeURL));
          const response = await axios.get(
            "https://maps.googleapis.com/maps/api/geocode/json?new_forward_geocoder=true&address=" +
            locationURL +
            "&key=" +
            process.env.REACT_APP_GOOGLE_MAP_API_KEY
          );
          const address = response.data.results[0];
          // console.log(address);
          if (place.formatted_address === undefined) {
            const selectedPlace = {
              formatted_address: address.formatted_address,
              latitude: address.geometry.location.lat,
              longitude: address.geometry.location.lng,
            }; //console.log(selectedPlace);
            setCustomval(address.formatted_address);
            dispatch(ramactions.updateLocation(selectedPlace));
          }
        }
        if (typeURL === "topic") {
          // console.log(keywordURL);
          if (parseInt(categoryURL) > 0) {
            const topcatid = parseInt(categoryURL);
            const subtopcatid = parseInt(subcategoryURL);
            dispatch(ramactions.updateCategory(topcatid));
            dispatch(ramactions.updatesubCategory(subtopcatid));

            const languages = languagesURL.split(",");
            const resourceType = resourceTypeURL.split(",");
            const communities = communitiesURL.split(",");
            const accessibilities = accessibilitiesURL.split(",");
            const costs = costsURL.split(",");
            let resourceTypeArr;
            if (resourceType.length > 1) resourceTypeArr = ["any"];
            else resourceTypeArr = resourceType;
            dispatch(ramactions.updateLanguages(languages));
            dispatch(ramactions.updateResourceType(resourceTypeArr));
            dispatch(ramactions.updateCommunities(communities));
            dispatch(ramactions.updateAccessibility(accessibilities));
            dispatch(ramactions.updateCost(costs));
          }
        } else {
          // console.log(keywordURL);
          dispatch(ramactions.updateKeyword(keywordURL));
        }
      } catch (err) {
        dispatch(ramactions.updateErrormsg(err));
        dispatch(ramactions.updateErrorstatus(1));
      }
    }
    //console.log(keyword);
    if (categoryURL > 0) setIssearchtypevisible(true);
    // if (subCategoryId > 0) setIssearchtypevisible(true);
    if (keyword !== null && keyword.length > 0) setIssearchtypevisible(true);
  }, [keyword, subCategoryId, isDisplayresult]);

  useEffect(() => {
    window.initAutocomplete = () => {
      var autocomplete = new window.google.maps.places.Autocomplete(
        /** @type {HTMLInputElement} */
        (document.getElementById("autocomplete")),
        {
          componentRestrictions: { country: "ca" },
          strictBounds: true,
          types: ["geocode"],
        }
      );
      window.google.maps.event.addListener(
        autocomplete,
        "place_changed",
        function () {
          var place = autocomplete.getPlace();
          setCustomval(place.formatted_address);
          //console.log(place);
          const selectedPlace = {
            formatted_address: place.formatted_address,
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
          };
          dispatch(ramactions.updateLocation(selectedPlace));
          if (queryParams.has("location")) {
            queryParams.delete("location");
          }
          if (queryParams.has("topic")) {
            queryParams.delete("topic");
          }
          if (queryParams.has("category") > 0) {
            const topcatid = queryParams.get("category");
            dispatch(ramactions.updateCategory(topcatid));
          }
          // history.replace({
          //   search: "?location=" + place.formatted_address + "&type=topic",
          // });
          if(categoryId > 0)
          {
            history.replace({
              search: "?location=" + place.formatted_address + "&type=topic&category=" + categoryId,
            });
            // dispatch(ramactions.updateCategory(categoryId));
          }
          else{
            history.replace({
              search:
                "?location=" + place.formatted_address + "&type=topic",
            });
            dispatch(ramactions.updateCategory(0));
          }
          dispatch(ramactions.updateSeachBy("topic"));
          
          dispatch(ramactions.updatesubCategory(0));
          dispatch(ramactions.updateKeyword(""));
          setShowGetCurrentLocation(false);
          setIssearchtypevisible(true);
          setIsValidLocation(true);
        }
      );
    };
  }, [isDisplayresult,categoryId]);

  useEffect(() => {
    if (
      place.formatted_address !== undefined &&
      place.formatted_address.length > 0
    )
      setCustomval(place.formatted_address);
    window.addEventListener("load", function () {
      document.querySelector('.search_input input[type="text"]').focus();
    });
  }, []);
  const onChangehandler = (e) => {
    // console.log("This is the reason!!");
    setCustomval(e.target.value);
    //if (customval.trim().length === 0) setIssearchtypevisible(false);
    //dispatch(ramactions.updateCategory(0));
    //dispatch(ramactions.updatesubCategory(0));
    //dispatch(ramactions.updateKeyword(""));
    if(categoryId > 0)
    {
      dispatch(ramactions.updateSeachBy("topic"));
      setShowGetCurrentLocation(true);
      setIssearchtypevisible(true);
      setIsValidLocation(false);
    }
    else
    {
      dispatch(ramactions.updateSeachBy("topic"));
      setShowGetCurrentLocation(true);
      setIssearchtypevisible(false);
      setIsValidLocation(false);
      history.push({
        search: "",
      });
    }
  };
  /*const favoritearray = useSelector((index) => index.favoritearray);

  useEffect(()=>{
    console.log(favoritearray);
  },[favoritearray])*/

  useEffect(() => {
    if (!isDisplayresult) {
      if (queryParams.has("resourceType")) {
        queryParams.delete("subcategory");
      }
      if (queryParams.has("languages")) {
        queryParams.delete("languages");
      }
      if (queryParams.has("communities")) {
        queryParams.delete("communities");
      }
      if (queryParams.has("accessibilities")) {
        queryParams.delete("accessibilities");
      }
      if (queryParams.has("costs")) {
        queryParams.delete("costs");
      }
    }
  }, [isDisplayresult]);

  const doPlaceSeclect = (place) => {
    setCustomval(place.formatted_address);
    //console.log(place);
    const selectedPlace = {
      formatted_address: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
    };
    dispatch(ramactions.updateLocation(selectedPlace));
    if (queryParams.has("location")) {
      queryParams.delete("location");
    }
    if (queryParams.has("topic")) {
      queryParams.delete("topic");
    }
    history.replace({
      search:
        "?location=" +
        place.formatted_address +
        "&type=topic" +
        queryParams.toString(),
    });
  };

  const searchhanddler = () => {
    if (customval.trim().length > 0) {
      setIssearchtypevisible(true);
      setIsValidLocation(true);
    } else {
      // if(categoryId == 0)
      // {
        setIssearchtypevisible(false);
        setIsValidLocation(false);
        document.querySelector('.search_input input[type="text"]').focus();
      // }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      searchhanddler();
    }
  };

  const onSearchtypeChangehanddler = (isShow) => {
    setDisplaysearchresult(isShow);
    porps.resultShowStatusHandler(true);
  };

  const backtohome = () => {
    ///setDisplaysearchresult(false);
    dispatch(ramactions.toogleSeachresultdisplay(false));
    porps.resultShowStatusHandler(false);
  };

  const getcurrentlocation = async () => {
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
      timeout: 10000,
    });
  };

  const successCallback = async (position) => {
    try {
      const lat = position.coords.latitude;
      const long = position.coords.longitude;
      const latlng = new window.google.maps.LatLng(lat, long);
      //console.log(latlng);
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ latLng: latlng }, function (results, status) {
        if (status == window.google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            const selectedPlace = {
              formatted_address: results[0].formatted_address,
              latitude: lat,
              longitude: long,
            };
            dispatch(ramactions.updateLocation(selectedPlace));
            //console.log(response.data.results[9]);
            setCustomval(results[0].formatted_address);
            if (queryParams.has("location")) {
              queryParams.delete("location");
            }
            if (queryParams.has("topic")) {
              queryParams.delete("topic");
            }
           
            if(categoryId > 0)
            {
              history.replace({
                search: "?location=" + results[0].formatted_address + "&type=topic&category=" + categoryId,
              });
            }
            else{
              history.replace({
                search:
                  "?location=" + results[0].formatted_address + "&type=topic",
              });
            }
            setShowGetCurrentLocation(false);
            setIssearchtypevisible(true);
            setIsValidLocation(true);
          } else {
            setIsValidLocation(false);
          }
        }
      });

      //searchhanddler();
    } catch (err) {
      //console.log(err);
      dispatch(ramactions.updateErrormsg(err));
      dispatch(ramactions.updateErrorstatus(1));
      setShowGetCurrentLocation(true);
    }
  };

  const errorCallback = (e) => {
    //console.log(e);
  };

  return (
    <Fragment>
      {!isDisplayresult && (
        <Fragment>
          <Helmet>
            <script
              src={
                "https://maps.googleapis.com/maps/api/js?key=" +
                process.env.REACT_APP_GOOGLE_MAP_API_KEY +
                "&language=" +
                webLanguage +
                "&libraries=places&callback=initAutocomplete"
              }
              async
              defer
            />
          </Helmet>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-8 col-lg-6 col-md-8">
                <div className="welcome-txt text-center">
                  <h1 className="header-three">
                    {t("page_title")}
                    <span className="header-one">
                      {t("find_support_across_canada")}
                    </span>
                  </h1>
                  <p>{t("page_description")}</p>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}
      {/* {isDisplayresult && (
          <button onClick={backtohome}>Back to search home</button>
        )} */}
      {!isDisplayresult && (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-4 col-lg-6 col-md-8">
              <div className="form-group">
                <div className="search_input">
                  <input
                    type="text"
                    value={customval}
                    onChange={onChangehandler}
                    className="form-control autocomplete_search autocomplete_search_landing"
                    onKeyDown={handleKeyDown}
                    name="autocomplete"
                    id="autocomplete"
                    aria-describedby={!isValidLocation && "location-error"}
                  />
                  <button
                    onClick={searchhanddler}
                    className="search-btn search-btn-landing"
                    aria-label="Search"
                  ></button>
                  {!isValidLocation && (
                    <p className="error-msg" id="location-error">
                      {t("location_field_error")}
                    </p>
                  )}
                </div>
              </div>
              {showGetCurrentLocation && (
                <div className="form-group current__location text-center">
                  <Link onClick={getcurrentlocation} className="get_location">
                    <span class="bts bt-map-arrow" aria-hidden="true"></span>
                    {t("use_current_location")}
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <Fragment>
        {issearchtypevisible && (
          <Searchtype
            onSearchtypeChange={onSearchtypeChangehanddler}
            goToHome={backtohome}
          ></Searchtype>
        )}
      </Fragment>
    </Fragment>
  );
};

export default Landing;
